// extracted by mini-css-extract-plugin
module.exports = {"reactImages__viewImage":"layout-module--react-images__view-image--3SFlk","page":"layout-module--page--2M1qH"};